export const EditForm = ({ children }) => {
  return (
    <div className='container-wrap hsp-form guard-info-form btn-fixed'>
      <div className='content-area'>{children}</div>
    </div>
  );
};
